const isProd = typeof window.search_results_parts !== 'undefined'

export default isProd
